/** A list of the months as an array of objects
 * where each object has a value property starting from 0,
 * and a label property with the month's name
 */
export const months = [
  { value: 0, label: "January" },
  { value: 1, label: "February" },
  { value: 2, label: "March" },
  { value: 3, label: "April" },
  { value: 4, label: "May" },
  { value: 5, label: "June" },
  { value: 6, label: "July" },
  { value: 7, label: "August" },
  { value: 8, label: "September" },
  { value: 9, label: "October" },
  { value: 10, label: "November" },
  { value: 11, label: "December" },
];

/**
 * Generate an array of years from 1950 up till the current year,
 * to use in the year dropdown field
 */
export const getYearsUpTillNow = () => {
  const currentYear = new Date().getYear() + 1900;
  let years = [];
  for (let i = 1950; i <= currentYear; i++) years.push(i);
  return [...years];
};

/**
 * Generate a list of day from 1 to 31
 */

export const getDays = () => {
  let days = [];
  for (let i = 1; i <= 31; i++) days.push(i);
  return days;
};
